import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=5da00ae1&"
import script from "./AppIndex.vue?vue&type=script&lang=js&"
export * from "./AppIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da00ae1')) {
      api.createRecord('5da00ae1', component.options)
    } else {
      api.reload('5da00ae1', component.options)
    }
    module.hot.accept("./AppIndex.vue?vue&type=template&id=5da00ae1&", function () {
      api.rerender('5da00ae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppIndex.vue"
export default component.exports